/**
 * Given by criteria, IDs and content blocker ID decide if the consent is given.
 */
function decideToUnblock(by, requiredIds, blockerId, checker) {
  var required = typeof requiredIds === "string" ? requiredIds.split(",").map(Number) : requiredIds;
  return checker(by, required, blockerId);
}

export { decideToUnblock };